import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable, of } from 'rxjs';

import { DotFitter } from '@sc/data-access-models';

import {
  DotFittersClearedAction,
  DotFittersAddedAction,
  DotFittersState,
  DotFittersShowMoreAction,
} from '../../store';

@Injectable({
  providedIn: 'root',
})
export class DotFittersSandboxService {
  @Select(DotFittersState)
  public dotFitters$: Observable<DotFitter[]>;

  @Dispatch()
  public addDotFitters(
    dotFitters: DotFitter[]
  ): Observable<DotFittersAddedAction> {
    return of(new DotFittersAddedAction(dotFitters));
  }

  @Dispatch()
  public clearDotFitters(): Observable<DotFittersClearedAction> {
    return of(new DotFittersClearedAction());
  }

  @Dispatch()
  public showMoreDotFitters(): Observable<DotFittersShowMoreAction> {
    return of(new DotFittersShowMoreAction());
  }
}
